/** Key status chip + date formatting (shared presentational bits). */

const KEY_STATUS_STYLES: Record<string, string> = {
  active: 'text-green-700 bg-green-50 dark:bg-green-900/20 dark:text-green-300',
  suspended: 'text-amber-700 bg-amber-50 dark:bg-amber-900/20 dark:text-amber-300',
  revoked: 'text-red-700 bg-red-50 dark:bg-red-900/20 dark:text-red-300',
  expired: 'text-gray-700 bg-gray-100 dark:bg-gray-700 dark:text-gray-300',
};

export function KeyStatusChip({ status, label }: { status: string; label: string }) {
  return (
    <span
      className={`inline-flex items-center rounded px-2 py-0.5 text-xs font-medium ${
        KEY_STATUS_STYLES[status] ?? KEY_STATUS_STYLES.expired
      }`}
      data-status={status}
    >
      {label}
    </span>
  );
}

// eslint-disable-next-line react-refresh/only-export-components -- helper puro junto al chip
export function formatDateTime(value?: string | null): string {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleString();
}
